import { width } from 'components/CustomComponents/Card/CardStyles';
import CardHeading from 'components/CustomComponents/CardHeading';
import CustomDropdown from 'components/CustomComponents/CustomDropDown';
import CustomTextInput from 'components/CustomComponents/CustomtextInput';
import DynamicCard from 'components/CustomComponents/DynamicCard';
import Loader from 'components/CustomComponents/Loader';
import logFirebaseEvents from 'components/LogFirebaseEvents';
import { ACH, appTheme, CHECKING_CARD_CODE } from 'helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from 'network/NetworkUtils';
import { GET_ACCOUNTS_FOR_TRANSFER, GET_NEW_TRANSFER_ACCOUNTS, SAVING_CARD_CODE, STATUS_SUCCESS_CODE } from 'network/URLConstants';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { handleAmountInputLimitTo2decimal, retrieveData } from 'utils';






const DepositMoneyForm = (props) => {

    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    // const kudzuPlusTrue = false;
    const appThemeData = appTheme(kudzuPlusTrue);
    const location = useLocation();
    const { onNextSelect, onConfirmDisplayData, onDepositFundPayload } = props
    const { t } = useTranslation();
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const currentPath = window.location.pathname;

    const secureCreditDepositMoneyPayloadObj = useSelector(state => state.secureCreditDepositMoneyPayload);
    const accessToken = useSelector(state => state.accessToken);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessTokenToApi = useSelector(state => state.accessToken);
    const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
    const selectedItem = cards?.[0];
    const SavingsAccount = cards?.find(({ AccountTypeBit63 }) => AccountTypeBit63 === SAVING_CARD_CODE);

    const [isLoading, setIsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [transferFromAccountOptions, setTransferFromAccountOptions] = useState([]);
    const [isShowContent, setIsShowContent] = useState(false);
    const [isReset, setIsReset] = useState(false);

    const [transferFromError, setTransferFromError] = useState(null);
    const [amountError, setAmountError] = useState('');
    const cardDetails = useSelector(state => state.selectedCardDetails);


    const selectedTransferFromAccount = secureCreditDepositMoneyPayloadObj?.FromAccount;
    const enteredAmount = secureCreditDepositMoneyPayloadObj?.Amount;

    const spendingCard = cards?.find(
        (item) =>
            item.AccountTypeBit63 === 64
    );

    const [selectedMainCard, setSelectedMainCard] = useState(null);
    ////API CALLS-----------------------------------------




    const fetchAccounts = async () => {
        if (cards == undefined || cards == null) {
            return
        }
        var cardKey = cards !== null ? cards[0].CardKey : 0
        var isSavingsCard = false
        for (var i = 0; i < cards.length; i++) {
            if (global.selectedAccountServiceCardKey == cards[i].CardKey) {
                cardKey = cards[i].CardKey
                if (cards[i].AccountTypeBit63 == SAVING_CARD_CODE) {
                    isSavingsCard = true
                }
            }
        }
        try {
            setIsLoading(true);

            const deviceId = await retrieveData('updatedDeviceId')
            // const cardKey = cards !== null ?  cards[0].CardKey : 0;  //checking cardkey
            //get verified user account
            const url = GET_ACCOUNTS_FOR_TRANSFER.replace('{CARD_KEY}', cardKey) + '?statusCode=ACT&ach=false'

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            setIsShowContent(true);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                var accounts = []

                let spendingCard = responseJson.Response.Accounts.find(account => account.AccountType === "Spending");
                accounts = responseJson.Response.Accounts.filter(account => account.AccountType != "Spending");
                setAccounts(accounts);
                setTransferFromAccountOptions(accounts);
                // console.log(accounts);
                // console.log(responseJson)
                // console.log(transferFromAccountOptions)
                setSelectedMainCard(spendingCard);
                // debugger;




                setIsShowContent(true);
            }

        } catch (error) {
            dispatch({ type: 'TRANSFER_ACCOUNTS', payload: { transferAccounts: null } });
        }
    }



    useEffect(() => {
        fetchAccounts();
    }, [])






    useEffect(() => {

        if (selectedTransferFromAccount) setTransferFromError("")


    }, [selectedTransferFromAccount, isShowContent])




    // Amount Validation Logic--------
    const amountValidation = () => {
        let checkingBalance = 0
        let checkingCardKey = 0
        let savingBalance = 0
        let savingCardKey = 0
        let primaryCardkey = 0
        let primaryCardBalance = 0

        if (cards !== null) {
            if (SavingsAccount) {
                savingBalance = SavingsAccount.Balance
                savingCardKey = SavingsAccount.CardKey
            }
            checkingBalance = cards[0].Balance
            checkingCardKey = cards[0].CardKey
            const primaryKey = cards.find(card => card?.AccountTypeBit63 === 1);
            primaryCardkey = primaryKey?.CardKey;
            primaryCardBalance = primaryKey?.Balance

        }
        //if internal account
        if (selectedTransferFromAccount && selectedTransferFromAccount.ACHAccountInternalId === 0) {
            //if checking card and amount is more than balance
            if (selectedTransferFromAccount.AccountId === checkingCardKey && enteredAmount > checkingBalance && enteredAmount !== 0) {
                setAmountError(`${t("amount_error_msg")}`)
            } else if (selectedTransferFromAccount.AccountId === checkingCardKey && enteredAmount <= checkingBalance && enteredAmount !== 0) {
                setAmountError('');
            }
            if (SavingsAccount) {

                if (selectedTransferFromAccount.AccountId === savingCardKey && enteredAmount > savingBalance && enteredAmount !== 0) {
                    setAmountError(`${t("amount_error_msg")}`)
                }
                else if (selectedTransferFromAccount.AccountId === savingCardKey && enteredAmount <= savingBalance && enteredAmount !== 0) {
                    setAmountError('')
                }
            }

            if (selectedTransferFromAccount.AccountId === primaryCardkey && enteredAmount > primaryCardBalance && enteredAmount !== 0) {
                setAmountError(`${t("amount_error_msg")}`)
            } else if (selectedTransferFromAccount.AccountId === primaryCardkey && enteredAmount <= primaryCardBalance && enteredAmount !== 0) {
                setAmountError('')
            }
        }
    }

    useEffect(() => {
        if (enteredAmount) amountValidation();
    }, [enteredAmount, selectedTransferFromAccount])

    const handleOnBlurAmountField = (e) => {

        if (enteredAmount) amountValidation();
        else setAmountError("Please enter amount")

    }


    //onSubmit Validation-----------
    const handleValidation = () => {
        let isProceed = true;
        const reqError = "Required"
        if (!selectedTransferFromAccount) {
            setTransferFromError('Please select Account.')
            isProceed = false
        }

        if (!enteredAmount) {
            setAmountError('Please enter amount.')
            isProceed = false
        }
        if (amountError == t('amount_error_msg')) {
            setAmountError(t('amount_error_msg'))
            isProceed = false
        }

        return isProceed;
    }

    //on successful process setData
    const setDataOnSubmit = () => {


        let transferFundPayloadObj = {
            "FromAccount": selectedTransferFromAccount?.AccountId.toString(),
            "FromAccountType": selectedTransferFromAccount?.AccountType,
            "ToAccount": selectedMainCard?.AccountId.toString(),
            "ToAccountType": selectedMainCard?.AccountType,
            "Amount": enteredAmount,
            "SelectFromAccount": selectedTransferFromAccount
        }

        // var transferDateStatus = dateComparison(formattedTransferDate)

        const confirmDisplayData = [
            {
                title: t("transfer_money_to"),
                value: selectedMainCard?.AccountName || ''
            },
            {
                title: t("transfer_money_from"),
                value: selectedTransferFromAccount?.AccountName || ''
            },
            {
                title: t("amount"),
                value: enteredAmount
            }

        ]

        onDepositFundPayload(transferFundPayloadObj)
        onConfirmDisplayData(confirmDisplayData)
        onNextSelect(true);
    }

    const handleNextClick = () => {
        logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Next_Clicked", "Next_Clicked", "", "");
        const isProceed = handleValidation();
        if (isProceed) {
            setDataOnSubmit();
        }


    }

    const resetEachFieldValue = () => {
        setTransferFromAccountOptions(accounts)
        setTransferFromError(null)
        setAmountError('')

        const depositMoneyPayload = {
            "FromAccount": null,
            "ToAccount": null,
            "Amount": null,

        }

        dispatch({ type: "SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD", payload: { depositMoneyPayload } })
    }

    const handleReset = () => {
        logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Reset_Account_Clicked", "Reset_Account_Clicked", "", "");
        resetEachFieldValue();
        setIsReset(prev => !prev);
        dispatch({ type: "RESET_SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD" })
    }








    const getSubHeaderText = () => {

        const remaining = 200 - (spendingCard?.Balance || 0);
        return `You need at least $${remaining.toFixed(2)} more in your spending account to get your secured credit card.`;
    }


    const depositFundsFormChildren = () => {
        return (
            <>

                <div className="w-full">
                    <div className="mx-auto w-full max-w-[360px] sm:max-w-[520px] md:max-w-[640px] px-4 sm:px-0">

                        <hr
                            className="
                                w-full max-w-[700px]
                                border-t-[2.5px] border-[#A3CEBB]
                                opacity-50 rounded-full
                                mx-auto"
                        />

                        <p className="pt-4 mt-4
                                font-hanken-grotesk font-[400]
                                text-[20px] leading-[28px]
                                sm:text-[22px] sm:leading-[30px]
                                md:text-[24px] md:leading-[34px]
                                lg:text-[26px] lg:leading-[38px]
                                text-[var(--transferHeading-text)]
                                px-4 sm:px-0
                                max-w-[40ch]
                            ">
                            {t("DEPOSIT_FUNDS_SUBHEADING1")}
                        </p>

                        <p
                            className="
          font-hanken-grotesk font-[400]
          text-[18px] leading-[26px]
          sm:text-[20px] sm:leading-[28px]
          md:text-[22px] md:leading-[32px]
          lg:text-[26px] lg:leading-[38px]
          text-[var(--transferSubHeading-text)]
          px-4 sm:px-0
          max-w-[52ch]
        "
                        >
                            {getSubHeaderText()}
                        </p>

                        <div className="flex justify-center w-full mt-8 px-4 sm:px-0">
                            <div className="w-full sm:w-[80%] max-w-[640px] flex flex-col gap-8">

                                <div className="mt-6 flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
                                    <p className={`font-hanken-grotesk text-[16px] leading-[24px] font-medium ${kudzuPlusTrue ? 'text-[var(--text-clr-transactions)]' : 'text-[#262B3A]'} max-w-[20ch] break-words`}>
                                        {selectedMainCard?.AccountName}
                                    </p>

                                    <p className="font-hanken-grotesk text-[16px] leading-[24px] mt-2 font-medium text-[#559C7E] whitespace-nowrap text-right">
                                        {`$${spendingCard?.Balance?.toFixed(2)} Available`}
                                    </p>
                                </div>

                                <hr tabIndex={-2} className={`w-full
                                    border-0 border-t-2 ${kudzuPlusTrue ? 'bg-[#94C3E8]' : 'bg-[#94C3E8]'}  
                                     rounded h-[2px]`}
                                />

                                {isShowContent && (
                                    <CustomDropdown
                                        options={
                                            transferFromAccountOptions.length > 0
                                                ? transferFromAccountOptions
                                                : [{ Name: t("no_linked_acccounts") }]
                                        }
                                        title={t("transfer_money_from")}
                                        onSelect={(option) => {
                                            dispatch({
                                                type: "SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD",
                                                payload: { key: "FromAccount", value: option },
                                            });
                                        }}
                                        selectedAccountType={selectedTransferFromAccount}
                                        hrbg="bg-[#94C3E8]"
                                        balanceFontColor="text-[#559C7E]"
                                        error={transferFromError}
                                    />
                                )}

                                <CustomTextInput
                                    name={t("amount")}
                                    onChange={(event) => {
                                        const inputValue = event.target.value;
                                        const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
                                        setAmountError("");
                                        dispatch({
                                            type: "SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD",
                                            payload: {
                                                key: "Amount",
                                                value: formattedAmount.toString().replace("$", ""),
                                            },
                                        });
                                    }}
                                    value={enteredAmount ? `$${enteredAmount}` : ""}
                                    onBlur={(event) => handleOnBlurAmountField(event)}
                                    error={amountError}
                                    placeholder={"$ 0"}
                                    inputWidth="w-full"
                                />
                            </div>
                        </div>

                        <div className='flex sm:justify-end justify-between md:pb-20 sm:pb-10 pb-20  pt-10 gap-11 sm:mx-0 mx-4 relative z-10 pointer-events-auto'>
                            <button type="button" className=' font-hanken-grotesk font-[600] relative z-20
                                     md:font-[700] leading-[26px] 
                                     lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                      md:leading-[13px]
                                      lg:leading-[18px] text-[var(--resetTextColor)] cursor-pointer 
                                      capitalize' onClick={handleReset}>{t("reset")}</button>

                                <button type="button" disabled={amountError ? true : false} className='font-hanken-grotesk flex items-center font-[600] md:font-[700] relative z-20 
                         leading-[26px] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                          md:leading-[13px] 
                          lg:leading-[18px] text-[var(--resetTextColor)] cursor-pointer ' onClick={handleNextClick}>
                                {t("next")}<img src={appThemeData.transferRightArrow} alt="RadialNull" className='lg:h-[15px] lg:w-[14px]
                        md:h-[14px] md:w-[13px] sm:h-[12px] sm:w-[12px] h-[13px] w-[14px] ml-1' /></button>
                        </div>
                    </div>
                </div>

            </>
        );
    };



    return (

        <>
            <DynamicCard
                CardRadius={true}
                cardWidth={width.allpolicies}
                HeaderRadius={true}
                isWhite={appThemeData.isWhiteBgForCard}
                isDarkForKudzu={appThemeData.isDarkBgForCard}
                header={false}
                footer={true}
                backgroundColor={'--cardHeading-bg'}
                HeaderContent={
                    <>
                        <CardHeading heading={t('DEPOSIT_FUNDS_HEADER')} />
                    </>
                }


            >
                {depositFundsFormChildren()}
            </DynamicCard>

            {isLoading && <Loader />}
        </>
    )
};
export default DepositMoneyForm;